var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('feature-page',{attrs:{"text":_vm.$t('whiteLabelFeaturesPage.landlordToTenant.text'),"features":_vm.features}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }